import React from 'react';
import { Container, Typography, Box, List, ListItem, ListItemText } from '@mui/material';
import { theme } from '../styles/theme'; // Assuming this path is correct

const TermsAndConditions = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: theme.palette.background.default }}>
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Typography variant="h2" component="h1" align="center" sx={{ color: theme.palette.primary.main, mb: 4 }}>
          Terms and Conditions
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Welcome to Yogi Plus Water Tank (the "App"). These terms and conditions ("Terms") outline the rules and regulations for the use of the Yogi Plus Water Tank mobile application and website (collectively, the "Platform") operated by Yogi Plus Water Tank, an entity registered in India
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          By accessing and using this Platform, you ("User" or "You") accept and agree to be bound by these Terms and Conditions and our Privacy Policy. If you do not agree to all the terms and conditions stated on this page, please do not use our Platform.
        </Typography>

        {/* Section 1: Definitions */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          1. Definitions
        </Typography>
        <List sx={{ ml: 2 }}>
          <ListItem disablePadding>
            <ListItemText primary="1.1. " secondary="“App” or “Platform” refers to the Yogi Plus Water Tank mobile application and website." />
          </ListItem>
          <ListItem disablePadding>
            <ListItemText primary="1.2. " secondary="“User,” “You,” or “Your” refers to the individual or entity accessing or using the Platform to browse, purchase, or interact with our services." />
          </ListItem>
          <ListItem disablePadding>
            <ListItemText primary="1.3. " secondary="“We,” “Us,” or “Our” refers to Yogi Plus Water Tank, the owner and operator of the Yogi Plus Water Tank Platform." />
          </ListItem>
          <ListItem disablePadding>
            <ListItemText primary="1.4. " secondary="“Products” refer to the water tanks and related accessories sold through the Platform." />
          </ListItem>
          <ListItem disablePadding>
            <ListItemText primary="1.5. " secondary="“Order” refers to a request made by a User for the purchase of Products through the Platform." />
          </ListItem>
        </List>

        {/* Section 2: Eligibility */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          2. Eligibility
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Use of the Platform is available only to persons who can form legally binding contracts under the Indian Contract Act, 1872. By using this Platform, you represent that you are at least 18 years old and competent to enter into a legally binding agreement. If you are a minor (under 18 years), you may use the Platform only with the involvement of a parent or guardian.
        </Typography>

        {/* Section 3: User Accounts */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          3. User Accounts
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          To access certain features of the Platform and make purchases, you may be required to register for an account. You agree to:
        </Typography>
        <List sx={{ ml: 2, listStyleType: 'decimal' }}>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Provide accurate, current, and complete information during the registration process." />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Maintain the security of your password and identification." />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Promptly update your registration data and any other information you provide to Us to keep it accurate, current, and complete." />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Accept all risks of unauthorized access to your account and the information you provide to Us." />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Notify Us immediately of any unauthorized use of your account or any other breach of security." />
          </ListItem>
        </List>
        <Typography variant="body1" sx={{ mb: 3 }}>
          We reserve the right to suspend or terminate your account and refuse any and all current or future use of the Platform if any information provided is inaccurate, not current, or incomplete, or if we have reasonable grounds to suspect that such information is inaccurate, not current, or incomplete.
        </Typography>

        {/* Section 4: Product Information and Pricing */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          4. Product Information and Pricing
        </Typography>
        <List sx={{ ml: 2, listStyleType: 'decimal' }}>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="We strive to provide accurate product descriptions, images, and pricing information. However, we do not warrant that product descriptions or other content on the Platform is entirely accurate, complete, reliable, current, or error-free." />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="All prices listed on the Platform are in Indian Rupees (INR) and are inclusive of applicable taxes unless otherwise stated. Delivery charges, if any, will be clearly indicated at checkout." />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Prices for our Products are subject to change without prior notice. We reserve the right at any time to modify or discontinue any Product without notice." />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="In the event of a pricing error for an item you have ordered, we will notify you and give you the option to reconfirm your order at the correct price or cancel it. If we are unable to contact you, we will treat the order as cancelled." />
          </ListItem>
        </List>

        {/* Section 5: Order Acceptance and Cancellation */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          5. Order Acceptance and Cancellation
        </Typography>
        <List sx={{ ml: 2, listStyleType: 'decimal' }}>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Your order constitutes an offer to us to buy a Product. All orders are subject to acceptance by us. We will confirm such acceptance to you by sending you an email or in-app notification confirming the dispatch of the Product." />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="We reserve the right to refuse or cancel any order for any reason, including but not limited to product unavailability, errors in pricing or product information, or issues with payment processing." />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="You may cancel an order before it has been dispatched. Once dispatched, our Returns and Refund Policy will apply." />
          </ListItem>
        </List>

        {/* Section 6: Payment Terms */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          6. Payment Terms
        </Typography>
        <List sx={{ ml: 2, listStyleType: 'decimal' }}>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="We accept COD as payment method." />
          </ListItem>
          {/* <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="You agree to provide current, complete, and accurate purchase and account information for all purchases made via the Platform." />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="You are responsible for all charges incurred under your account, whether by you or by anyone using your account." />
          </ListItem> */}
        </List>

        {/* Section 7: Delivery and Installation */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          7. Delivery and Installation
        </Typography>
        <List sx={{ ml: 2, listStyleType: 'decimal' }}>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Delivery of Products will be made to the address specified in your Order. We will make reasonable efforts to deliver Products within the estimated delivery timeframes, but we do not guarantee delivery dates." />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Risk of loss and title for Products pass to you upon our delivery to the carrier." />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Any installation services for water tanks, if offered, will be subject to separate terms and conditions provided by us or our third-party service providers. Yogi Plus Water Tank is not responsible for any damages or issues arising from improper installation by third parties not engaged by us." />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="You are responsible for ensuring the delivery location is accessible for the delivery of bulky items like water tanks." />
          </ListItem>
        </List>

        {/* Section 8: Returns, Refunds, and Warranty */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          8. Returns, Refunds, and Warranty
        </Typography>
        <List sx={{ ml: 2, listStyleType: 'decimal' }}>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Our Returns and Refund Policy, available at /refund, governs all product returns and refunds. Please review this policy carefully." />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="Products may be subject to manufacturer warranties. Details of such warranties, if any, will be provided with the Product or can be found on the manufacturer's website. Yogi Plus Water Tank does not provide any additional warranties beyond those offered by the manufacturer, unless explicitly stated." />
          </ListItem>
        </List>

        {/* Section 9: Intellectual Property Rights */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          9. Intellectual Property Rights
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          The Platform and all its content, including but not limited to text, graphics, logos, images, software, and the compilation thereof, are the property of Yogi Plus Water Tank or its licensors and are protected by Indian and international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          You may not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on our Platform, except as generally and ordinarily permitted through the Platform's functions.
        </Typography>

        {/* Section 10: Prohibited Uses */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          10. Prohibited Uses
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          You may use the Platform only for lawful purposes and in accordance with these Terms. You agree not to use the Platform:
        </Typography>
        <List sx={{ ml: 2, listStyleType: 'decimal' }}>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="In any way that violates any applicable national, state, local, or international law or regulation." />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="For the purpose of exploiting, harming, or attempting to exploit or harm minors in any way by exposing them to inappropriate content or otherwise." />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="To transmit, or procure the sending of, any advertising or promotional material, including any 'junk mail,' 'chain letter,' or any other similar solicitation." />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="To impersonate or attempt to impersonate Yogi Plus Water Tank, a Yogi Plus Water Tank employee, another user, or any other person or entity." />
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            <ListItemText primary="To engage in any other conduct that restricts or inhibits anyone's use or enjoyment of the Platform, or which, as determined by us, may harm Yogi Plus Water Tank or users of the Platform or expose them to liability." />
          </ListItem>
        </List>

        {/* Section 11: Disclaimer of Warranties */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          11. Disclaimer of Warranties
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          The Platform and all Products and services delivered to you through the Platform are provided "as is" and "as available" for your use, without any representation, warranties, or conditions of any kind, either express or implied, including all implied warranties or conditions of merchantability, merchantable quality, fitness for a particular purpose, durability, title, and non-infringement.
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          We do not guarantee, represent, or warrant that your use of our service will be uninterrupted, timely, secure, or error-free. We do not warrant that the results that may be obtained from the use of the service will be accurate or reliable.
        </Typography>

        {/* Section 12: Limitation of Liability */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          12. Limitation of Liability
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          In no case shall Yogi Plus Water Tank, its directors, officers, employees, affiliates, agents, contractors, interns, suppliers, service providers, or licensors be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind, including, without limitation lost profits, lost revenue, lost savings, loss of data, replacement costs, or any similar damages, whether based in contract, tort (including negligence), strict liability or otherwise, arising from your use of any of the service or any products procured using the service, or for any other claim related in any way to your use of the service or any product, including, but not limited to, any errors or omissions in any content, or any loss or damage of any kind incurred as a result of the use of the service or any content (or product) posted, transmitted, or otherwise made available via the service, even if advised of their possibility.
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Our total liability to you for any and all claims arising out of or relating to these Terms or your use of the Platform or Products, whether in contract, tort, or otherwise, shall not exceed the amount paid by you for the Product giving rise to the claim.
        </Typography>

        {/* Section 13: Indemnification */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          13. Indemnification
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          You agree to indemnify, defend, and hold harmless Yogi Plus Water Tank and its parent, subsidiaries, affiliates, partners, officers, directors, agents, contractors, licensors, service providers, subcontractors, suppliers, interns, and employees, harmless from any claim or demand, including reasonable attorneys’ fees, made by any third-party due to or arising out of your breach of these Terms of Service or the documents they incorporate by reference, or your violation of any law or the rights of a third-party.
        </Typography>

        {/* Section 14: Third-Party Links */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          14. Third-Party Links
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Certain content, products, and services available via our Platform may include materials from third parties. Third-party links on this Platform may direct you to third-party websites that are not affiliated with us. We are not responsible for examining or evaluating the content or accuracy and we do not warrant and will not have any liability or responsibility for any third-party materials or websites, or for any other materials, products, or services of third-parties.
        </Typography>

        {/* Section 15: Governing Law and Jurisdiction */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          15. Governing Law and Jurisdiction
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          These Terms and your use of the Platform shall be governed by and construed in accordance with the laws of India, specifically the laws of the State of Gujarat, without regard to its conflict of law principles. Any disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts in Ahmedabad, Gujarat, India.
        </Typography>

        {/* Section 16: Severability */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          16. Severability
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          In the event that any provision of these Terms is determined to be unlawful, void, or unenforceable, such provision shall nonetheless be enforceable to the fullest extent permitted by applicable law, and the unenforceable portion shall be deemed to be severed from these Terms, such determination shall not affect the validity and enforceability of any other remaining provisions.
        </Typography>

        {/* Section 17: Changes to Terms */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          17. Changes to Terms
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          We reserve the right, at our sole discretion, to update, change, or replace any part of these Terms by posting updates and changes to our Platform. It is your responsibility to check our Platform periodically for changes. Your continued use of or access to our Platform following the posting of any changes to these Terms constitutes acceptance of those changes.
        </Typography>

        {/* Section 18: Entire Agreement */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          18. Entire Agreement
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          These Terms and any policies or operating rules posted by us on this Platform or in respect to the service constitutes the entire agreement and understanding between you and us and govern your use of the service, superseding any prior or contemporaneous agreements, communications, and proposals, whether oral or written, between you and us (including, but not limited to, any prior versions of the Terms of Service).
        </Typography>

        {/* Section 19: Contact Information */}
        <Typography variant="h4" component="h2" sx={{ color: theme.palette.text.primary, mt: 4, mb: 2 }}>
          19. Contact Information
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Questions about the Terms and Conditions should be sent to us at yogipluswatertank@gmail.com.
        </Typography>

        <Typography variant="body2" align="center" sx={{ mt: 6, color: theme.palette.text.secondary }}>
          Last updated: June 10, 2025
        </Typography>
      </Container>
    </Box>
  );
};

export default TermsAndConditions;